import styles from "./WhyJalaram.module.css";
import { useScrollReveal } from "../../hooks/useScrollReveal";

const principles = [
  { number: "01", title: "Visibility", description: "Be seen where customers are." },
  { number: "02", title: "Consistency", description: "Make your brand recognizable." },
  { number: "03", title: "Execution", description: "Turn ideas into physical presence." },
];

function Principle({ number, title, description }: (typeof principles)[number]) {
  const ref = useScrollReveal<HTMLDivElement>();
  return (
    <div ref={ref} className={`${styles.pillar} reveal`}>
      <span className={styles.pillarNumber} aria-hidden="true">
        {number}
      </span>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

export function WhyJalaram() {
  return (
    <section id="about" className={styles.section} aria-labelledby="why-heading">
      <div className="container">
        <div className={styles.head}>
          <span className="eyebrow">Why Jalaram Ad.</span>
          <h2 id="why-heading">
            More Than a Sign.
            <br />A Brand Presence.
          </h2>
          <p>
            Every billboard, sign and branded space is an opportunity to make your business
            recognizable. Jalaram Ad. brings advertising, branding and signage together to create
            a consistent physical presence.
          </p>
        </div>

        <div className={styles.grid}>
          {principles.map((principle) => (
            <Principle key={principle.number} {...principle} />
          ))}
        </div>
      </div>
    </section>
  );
}
